import { FormGroup } from '@angular/forms';
var FlatInstructionsFormComponent = /** @class */ (function () {
    function FlatInstructionsFormComponent() {
    }
    Object.defineProperty(FlatInstructionsFormComponent.prototype, "flatInstructions", {
        get: function () {
            return this.treatment.get("flatInstructions");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FlatInstructionsFormComponent.prototype, "substrate", {
        get: function () {
            return this.flatInstructions.get("substrate");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FlatInstructionsFormComponent.prototype, "irrigation", {
        get: function () {
            return this.flatInstructions.get("irrigation");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FlatInstructionsFormComponent.prototype, "fertigation", {
        get: function () {
            return this.flatInstructions.get("fertigation");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FlatInstructionsFormComponent.prototype, "flatType", {
        get: function () {
            return this.flatInstructions.get("flatType");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FlatInstructionsFormComponent.prototype, "directSeedToPots", {
        get: function () {
            return this.flatInstructions.get("directSeedToPots");
        },
        enumerable: true,
        configurable: true
    });
    FlatInstructionsFormComponent.prototype.copyValueFrom = function (copyArgs) {
        this.flatInstructions.patchValue(copyArgs);
        this.flatInstructions.updateValueAndValidity();
    };
    return FlatInstructionsFormComponent;
}());
export { FlatInstructionsFormComponent };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/request-creation/experiment-design/flat-instructions/flat-instructions-form/flat-instructions-form.component.ts.pre-build-optimizer.js